'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

/**
 * DYOJ Customize Order Form Handler
 */

/**
  * Handle View All button clicks - open in new tab
  */
$(document).on('click', '.view-all-btn, .dyoj-categories-list .dyoj-categories', function (e) {
    e.preventDefault();
    var url = $(this).data('url');
    if (url) {
        window.open(url, '_blank');
    }
});

$(document).on('click', '.close-diamond', function () {
    $('#selectedDiamondDisplay').hide();
    $('#selectedDiamondName').text('');
    $('#selectedDiamond').val('');
    $('#selectedDiamondNameField').val('');
});

$(document).on('click', '.close-gemstone', function () {
    $('#selectedGemstoneDisplay').hide();
    $('#selectedGemstoneName').text('');
    $('#selectedGemstone').val('');
    $('#selectedGemstoneNameField').val('');
});

module.exports = {
    selectedFiles: [], // Array to accumulate multiple file selections

    /**
     * Scroll to the first visible error
     */
    scrollToFirstError: function () {
        var $container = $('.dyoj-customize-product');
        var $firstError = $container.find('.is-invalid').filter(':visible').first();

        if ($firstError.length === 0) {
            $firstError = $container.find('.dyoj-field-error, .dyoj-terms-error, .dyoj-video-field-error').filter(function () {
                return $(this).text().trim().length > 0 && $(this).is(':visible');
            }).first();
        }

        if ($firstError.length) {
            $('html, body').animate({
                scrollTop: $firstError.offset().top - 300
            }, 500);
        }
    },

    /**
     * Sync minus button disabled state using the `disablestate` class
     * @param {jQuery} $input - Quantity input
     */
    syncMinusDisableState: function ($input) {
        if (!$input || !$input.length) return;

        var $container = $input.closest('.ckc-quantity-selector');
        var $minus = $container.find('.ckc-qty-minus');
        var $minusIcon = $container.find('#minus-id');
        var $plus = $container.find('.ckc-qty-plus');

        var minVal = parseInt($input.attr('min'), 10);
        if (Number.isNaN(minVal)) {
            minVal = parseInt($input.attr('data-qty-min'), 10);
        }
        if (Number.isNaN(minVal)) minVal = 1;

        var maxVal = parseInt($input.attr('max'), 10);
        if (Number.isNaN(maxVal)) {
            maxVal = parseInt($input.attr('data-qty-max'), 10);
        }
        if (Number.isNaN(maxVal)) maxVal = 999;

        // Sync minus button
        setTimeout(function () {
            var currentValInner = parseInt($input.val(), 10);
            if (Number.isNaN(currentValInner)) currentValInner = minVal;

            if (currentValInner <= minVal) {
                $minus.addClass('disablestate').prop('disabled', true);
                $minus.removeClass('minusbutton');
                if ($minusIcon.length) {
                    $minusIcon.attr('xlink:href', '#minus-symbol-decre');
                }
            } else {
                $minus.removeClass('disablestate').prop('disabled', false);
                $minus.addClass('minusbutton');
                if ($minusIcon.length) {
                    $minusIcon.attr('xlink:href', '#minus-symbol-incre');
                }
            }
        }, 0);

        // Sync plus button
        // Use timeout to override any conflicting logic from productDetail.js/selectPDPQuantity.js
        setTimeout(function () {
            var currentValInner = parseInt($input.val(), 10);
            if (Number.isNaN(currentValInner)) currentValInner = minVal;

            if (currentValInner >= maxVal) {
                $plus.addClass('disablestate max-disabled').prop('disabled', true);
            } else {
                $plus.removeClass('disablestate max-disabled').prop('disabled', false);
            }
        }, 0);
    },

    /**
     * Get message from data attribute
     * @param {string} key - Message key
     * @returns {string} Message text
     */
    getMessage: function (key) {
        return $('.dyoj-customize-product').data('msg-' + key) || '';
    },

    /**
     * Create centered message HTML
     * @param {string} message - Message to display
     * @returns {string} HTML string
     */
    createCenteredMessage: function (message) {
        return '<div class="text-center py-5"><p>' + message + '</p></div>';
    },

    /**
     * Prevent default drag behavior
     * @param {Event} e - Event object
     */
    preventDragDefaults: function (e) {
        e.preventDefault();
        e.stopPropagation();
    },

    /**
     * Shared utility to update quantity input value
     * @param {jQuery} $input - Input element
     * @param {number} delta - Change amount (+1 or -1)
     */
    updateQuantity: function ($input, delta) {
        var currentVal = parseInt($input.val(), 10) || 1;
        var minVal = parseInt($input.attr('min'), 10) || 1;

        var maxVal = parseInt($input.attr('max'), 10);
        if (Number.isNaN(maxVal)) {
            maxVal = parseInt($input.attr('data-qty-max'), 10);
        }
        if (Number.isNaN(maxVal)) maxVal = 999;

        var newVal = currentVal + delta;

        if (newVal >= minVal && newVal <= maxVal) {
            $input.val(newVal);
        }

        this.syncMinusDisableState($input);
    },

    /**
     * Initialize quantity controls
     */
    initQuantityControls: function () {
        var self = this;

        $('.dyoj-customize-form')
            .off('click.dyojQty', '.quantity-increment')
            .on('click.dyojQty', '.quantity-increment', function (e) {
                e.preventDefault();
                self.updateQuantity($(this).siblings('input[name="quantity"]'), 1);
            });

        $('.dyoj-customize-form')
            .off('click.dyojQty', '.quantity-decrement')
            .on('click.dyojQty', '.quantity-decrement', function (e) {
                e.preventDefault();
                self.updateQuantity($(this).siblings('input[name="quantity"]'), -1);
            });

        $('.dyoj-customize-form')
            .off('click.dyojQty', '.ckc-qty-plus')
            .on('click.dyojQty', '.ckc-qty-plus', function (e) {
                e.preventDefault();
                self.updateQuantity($(this).siblings('input[name="quantity"], .c-qty-input[name="quantity"]').first(), 1);
            });

        $('.dyoj-customize-form')
            .off('click.dyojQty', '.ckc-qty-minus')
            .on('click.dyojQty', '.ckc-qty-minus', function (e) {
                e.preventDefault();
                self.updateQuantity($(this).siblings('input[name="quantity"], .c-qty-input[name="quantity"]').first(), -1);
            });

        $(document)
            .off('input.dyojQty change.dyojQty keyup.dyojQty blur.dyojQty', '.dyoj-customize-form input[name="quantity"]')
            .on('input.dyojQty change.dyojQty keyup.dyojQty blur.dyojQty', '.dyoj-customize-form input[name="quantity"]', function () {
                self.syncMinusDisableState($(this));
            });

        $('.dyoj-customize-form input[name="quantity"]').each(function () {
            self.syncMinusDisableState($(this));
        });
    },

    /**
     * Show alert message
     * @param {string} message - Alert message
     * @param {string} type - Alert type (success/danger)
     */
    showAlert: function (message) {
        toastMessageHelper.showNotification('', message);
    },

    /**
     * Clear field-level error UI
     * @param {jQuery} $field - field element
     */
    clearFieldError: function ($field) {
        if (!$field || !$field.length) return;

        var $formGroup = $field.closest('.form-group');
        $field.removeClass('is-invalid');
        if ($formGroup.length) {
            $formGroup.removeClass('has-error');
            $formGroup.find('.dyoj-inline-error').remove();
            $formGroup.find('.dyoj-field-error').addClass('d-none').text('');
        } else {
            // Non-form-group fields (e.g. upload input rendered outside <form>)
            $field.siblings('.dyoj-inline-error').remove();
            $field.closest('.upload-drop-zone, .dyoj-upload-section').find('> .dyoj-inline-error').remove();
            $field.closest('.upload-drop-zone').find('.dyoj-field-error').addClass('d-none').text('');
        }

        // Custom dropdown UI (native select is hidden)
        var $dropdown = $formGroup.find('.custom-drop-down');
        if ($dropdown.length) {
            $dropdown.removeClass('is-invalid');
        }
    },

    /**
     * Show field-level error UI
     * @param {jQuery} $field - field element
     * @param {string} message - error message
     */
    setFieldError: function ($field, message) {
        if (!$field || !$field.length) return;

        var msg = message || this.getMessage('required') || 'This field is required.';
        var $formGroup = $field.closest('.form-group');

        if ($formGroup.length) {
            $formGroup.addClass('has-error');
        }

        // Preferred: populate existing placeholder if present
        var $placeholder = $formGroup.length ? $formGroup.find('.dyoj-field-error') : $();

        // File upload input (rendered outside <form> via form attribute)
        if ($field.is('input[type="file"]')) {
            $field.addClass('is-invalid');
            var $uploadZone = $field.closest('.upload-drop-zone');
            if ($uploadZone.length) {
                var $uploadPlaceholder = $uploadZone.find('.dyoj-field-error');
                if ($uploadPlaceholder.length) {
                    $uploadPlaceholder.removeClass('d-none').text(msg);
                } else if (!$uploadZone.find('> .dyoj-inline-error').length) {
                    $uploadZone.append('<div class="invalid-feedback d-block dyoj-inline-error">' + msg + '</div>');
                }
            } else if (!$field.siblings('.dyoj-inline-error').length) {
                $field.after('<div class="invalid-feedback d-block dyoj-inline-error">' + msg + '</div>');
            }
            return;
        }

        // Custom dropdown UI (native select is hidden)
        if ($field.is('select') && $field.hasClass('custom-select')) {
            var $dropdown = $formGroup.find('.custom-drop-down');
            if ($dropdown.length) {
                $dropdown.addClass('is-invalid');
            }
            if ($placeholder.length) {
                $placeholder.removeClass('d-none').text(msg);
            } else if (!$formGroup.find('.dyoj-inline-error').length) {
                $formGroup.append('<div class="invalid-feedback d-block dyoj-inline-error">' + msg + '</div>');
            }
            return;
        }

        $field.addClass('is-invalid');
        if ($placeholder.length) {
            $placeholder.removeClass('d-none').text(msg);
        } else if ($formGroup.length && !$formGroup.find('.dyoj-inline-error').length) {
            $field.after('<div class="invalid-feedback d-block dyoj-inline-error">' + msg + '</div>');
        }
    },

    /**
     * Validate required fields on customize form
     * @param {jQuery} $form - form element
     * @returns {boolean} whether form is valid
     */
    validateCustomizeForm: function ($form) {
        var self = this;
        var isValid = true;

        if (!$form || !$form.length) return false;

        // Clear previous errors
        $form.find('.is-invalid').removeClass('is-invalid');
        $form.find('.has-error').removeClass('has-error');
        $form.find('.dyoj-inline-error').remove();
        $form.find('.dyoj-field-error').addClass('d-none').text('');

        // 1) Upload input is mandatory if present (it is rendered outside <form>)
        var $fileInput = $('#inspirationImages');
        if ($fileInput.length) {
            var $selectedFilesList = $('.selected-files-list');
            var hasFiles = false;

            // Primary check: if the UI list exists, it must have children
            if ($selectedFilesList.length) {
                hasFiles = $selectedFilesList.children().length > 0;
            } else {
                // Fallback check: internal state / native input
                hasFiles = (self.selectedFiles && self.selectedFiles.length)
                    || ($fileInput[0] && $fileInput[0].files && $fileInput[0].files.length);
            }
            if (!hasFiles) {
                self.setFieldError($fileInput, self.getMessage('upload-required') || 'Please upload an image.');
                isValid = false;
            }
        }

        // 2) Product net weight (readonly)
        var $netWeight = $form.find('input[name="productNetWeight"]').first();
        if ($netWeight.length) {
            var netWeightVal = ($netWeight.val() || '').toString().trim();
            if (!netWeightVal) {
                self.setFieldError($netWeight, self.getMessage('netweight-required') || 'Product net weight is required.');
                isValid = false;
            }
        }

        // 3) Product gross weight (readonly)
        var $grossWeight = $form.find('input[name="productGrossWeight"]').first();
        if ($grossWeight.length) {
            var grossWeightVal = ($grossWeight.val() || '').toString().trim();
            if (!grossWeightVal) {
                self.setFieldError($grossWeight, self.getMessage('grossweight-required') || 'Product gross weight is required.');
                isValid = false;
            }
        }

        // 4/5/6) Mandatory dropdowns: polish, setting, metal
        var requiredSelectIds = ['#polish', '#setting', '#metalType'];
        requiredSelectIds.forEach(function (selector) {
            var $select = $form.find(selector);
            if ($select.length) {
                var value = ($select.val() || '').toString().trim();
                if (!value) {
                    self.setFieldError($select, self.getMessage('select-option') || 'Please select an option.');
                    isValid = false;
                }
            }
        });

        // 7) Validate Video Link URL (optional, but if entered must be valid)
        var $videoLink = $('input[name="videoReferenceLink"]');
        if ($videoLink.length) {
            var videoUrl = ($videoLink.val() || '').toString().trim();
            // Basic URL validation pattern allowing query params
            // eslint-disable-next-line
            var urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?(\?.*)?$/;

            if (videoUrl && !urlPattern.test(videoUrl)) {
                var errorMsg = $videoLink.data('urlerror') || 'Please enter a valid URL';
                $videoLink.siblings('.invalid-feedback ')
                    .text(errorMsg)
                    .addClass('d-block')
                    .show();
                isValid = false;
            }
        }

        return isValid;
    },

    /**
     * Initializes video link input validation.
     *
     * On user input inside elements with class `.video-link-input`,
     * this function clears the error message and hides the
     * associated `.invalid-feedback` element.
     */
    initVideoLinkValidation: function () {
        $(document).on('input', '.video-link-input', function () {
            var $videoLink = $(this);
            $videoLink.siblings('.invalid-feedback').text('').removeClass('d-block').hide();
        });
    },

    /**
     * Initialize file upload with drag and drop
     */
    initFileUpload: function () {
        var $dropZone = $('#uploadDropZone');
        var $fileInput = $('#inspirationImages');
        var self = this;

        if (!$dropZone.length || !$fileInput.length) return;

        // Ensure selected files display starts hidden (no inline style)
        $('#selectedFilesDisplay').addClass('d-none').hide();

        // Prevent default drag behaviors
        $(document).on('dragover drop', function (e) {
            e.preventDefault();
        });

        // Drag over
        $dropZone.on('dragover', function (e) {
            self.preventDragDefaults(e);
            $(this).addClass('dragover');
        });

        // Drag leave
        $dropZone.on('dragleave', function (e) {
            self.preventDragDefaults(e);
            $(this).removeClass('dragover');
        });

        // Drop
        $dropZone.on('drop', function (e) {
            self.preventDragDefaults(e);
            $(this).removeClass('dragover');

            var files = e.originalEvent.dataTransfer.files;
            if (files.length) {
                self.addFilesToSelection(files);
                self.clearFieldError($fileInput);
            }
        });

        // File input change
        $fileInput.on('change', function () {
            if (this.files.length > 0) {
                self.addFilesToSelection(this.files);
                // self.clearFieldError($fileInput);
                // Clear the input so the same file can be selected again
                this.value = '';
            }
        });

        // Handle remove file
        $(document).on('click', '.remove-file-btn', function () {
            var index = $(this).data('index');
            self.removeFile(index);
        });
    },

    /**
     * Validate a single file for type and size
     * @param {File} file - File to validate
     * @returns {Object} validation result with isValid, errorType ('type'|'size'|null)
     */
    validateFile: function (file) {
        // var $fileInput = $('#inspirationImages');
        var allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        var maxSizeBytes = 5 * 1024 * 1024; // 5MB

        // Check file type
        if (allowedTypes.indexOf(file.type) === -1) {
            return { isValid: false, errorType: 'type', file: file };
        }

        // Check file size
        if (file.size > maxSizeBytes) {
            return { isValid: false, errorType: 'size', file: file };
        }

        return { isValid: true, errorType: null, file: file };
    },

    /**
     * Show file validation error message using data attributes
     * @param {string} errorType - 'type' or 'size'
     */
    showFileValidationError: function (errorType) {
        var $fileInput = $('#inspirationImages');
        var $uploadZone = $fileInput.closest('.upload-drop-zone');
        var $errorDiv = $uploadZone.find('.dyoj-field-error');

        var errorMsg = '';
        if (errorType === 'type') {
            errorMsg = $fileInput.data('filemissing');
        } else if (errorType === 'size') {
            errorMsg = $fileInput.data('fileerror');
        }

        if ($errorDiv.length && errorMsg) {
            $errorDiv.removeClass('d-none').text(errorMsg);
            $fileInput.addClass('is-invalid');
            this.scrollToFirstError();
        }
    },

    /**
     * Clear file validation error
     */
    clearFileValidationError: function () {
        var $fileInput = $('#inspirationImages');
        var $uploadZone = $fileInput.closest('.upload-drop-zone');
        var $errorDiv = $uploadZone.find('.dyoj-field-error');

        if ($errorDiv.length) {
            $errorDiv.addClass('d-none').text('');
        }
        $fileInput.removeClass('is-invalid');
    },

    /**
     * Add files to the selection (accumulate multiple uploads)
     * @param {FileList} newFiles - Files to add
     */
    addFilesToSelection: function (newFiles) {
        // var self = this;
        var hasError = false;
        var lastErrorType = null;

        // Clear previous validation errors
        this.clearFileValidationError();

        // Validate and add new files to the selectedFiles array
        for (var i = 0; i < newFiles.length; i++) {
            var validation = this.validateFile(newFiles[i]);
            if (validation.isValid) {
                this.selectedFiles.push(newFiles[i]);
            } else {
                hasError = true;
                lastErrorType = validation.errorType;
            }
        }

        // Show error for invalid files
        if (hasError) {
            this.showFileValidationError(lastErrorType);
        }

        // Update the file input with all accumulated files
        this.updateFileInput();

        // Display all files
        this.displaySelectedFiles(this.selectedFiles);
    },

    /**
     * Update the file input element with accumulated files
     */
    updateFileInput: function () {
        var $fileInput = $('#inspirationImages');
        var dt = new DataTransfer();

        for (var i = 0; i < this.selectedFiles.length; i++) {
            dt.items.add(this.selectedFiles[i]);
        }

        $fileInput[0].files = dt.files;
    },

    /**
     * Display selected files with previews
     * @param {Array} files - Array of files to display
     */
    displaySelectedFiles: function (files) {
        var $filesDisplay = $('#selectedFilesDisplay');
        var $filesList = $('.selected-files-list');

        if (files.length === 0) {
            $filesDisplay.addClass('d-none').hide();
            $filesList.empty();
            return;
        }

        $filesList.empty();

        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var fileItem = $('<div class="file-item" data-index="' + i + '"></div>');

            // File preview
            var filePreview = $('<div class="file-preview"></div>');
            if (file.type.startsWith('image/')) {
            //    var objectUrl = URL.createObjectURL(file);
            //     // persist the preview url on the file object so it can be appended to FormData later
            //     try { file.previewObjectUrl = objectUrl; } catch (e) {}
            //     filePreview.html('<img src="' + objectUrl + '" alt="Preview" />');

                var reader = new FileReader();
                reader.onload = (function (preview) {
                    return function (e) {
                        preview.html('<img src="' + e.target.result + '" alt="Preview" />');
                    };
                }(filePreview));
                reader.readAsDataURL(file);
            } else {
                filePreview.html('<i class="fa fa-file"></i>');
            }

            // File info
            var fileInfo = $('<div class="file-info"></div>');
            fileInfo.append('<div class="file-name">' + file.name + '</div>');
            fileInfo.append('<div class="file-size">' + this.formatFileSize(file.size) + '</div>');

            // Remove button
            var removeBtn = $('<button type="button" class="remove-file-btn" data-index="' + i + '">'
                + '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">'
                + '<path d="M0.75 10.75L10.75 0.751068" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>'
                + '<path d="M10.75 10.7489L0.75 0.75" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>'
                + '</svg></button>');

            fileItem.append(filePreview);
            fileItem.append(fileInfo);
            fileItem.append(removeBtn);
            $filesList.append(fileItem);
        }

        $filesDisplay.removeClass('d-none').show();
    },

    /**
     * Remove file from selection
     * @param {number} index - Index of file to remove
     */
    removeFile: function (index) {
        // Remove from selectedFiles array
        this.selectedFiles.splice(index, 1);

        // Update the file input
        this.updateFileInput();

        // Update display
        this.displaySelectedFiles(this.selectedFiles);
    },

    /**
     * Format file size
     * @param {number} bytes - File size in bytes
     * @returns {string} Formatted file size
     */
    formatFileSize: function (bytes) {
        if (bytes === 0) return '0 ' + this.getMessage('bytes');
        var k = 1024;
        var sizes = [
            this.getMessage('bytes'),
            this.getMessage('kb'),
            this.getMessage('mb'),
            this.getMessage('gb')
        ];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        var value = bytes / (k ** i);
        var rounded = Math.round(value * 100) / 100;
        return rounded + ' ' + sizes[i];
    },

    /**
     * Initialize delivery date picker
     */
    initDeliveryDate: function () {
        var $dateInput = $('#dyojDeliveryDate');
        if (!$dateInput.length) return;

        if ($.fn.datepicker && typeof $dateInput.datepicker === 'function') {
            $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            $dateInput
                .datepicker('destroy')
                .datepicker({
                    format: 'dd/mm/yyyy',
                    language: 'en',
                    autoclose: true,
                    todayHighlight: false,
                    startDate: '+0d',
                    weekStart: 1,
                    maxViewMode: 2,
                    templates: {
                        leftArrow: '',
                        rightArrow: ''
                    }
                });
        }
    },

    /**
     * Handle form submission
     */
    handleFormSubmit: function () {
        var self = this;

        // Use delegated handlers so events still fire if the form is re-rendered.
        // Also namespace events to avoid duplicate bindings when init() runs more than once.
        $(document)
            .off('change.dyojTerms', '.dyoj-customize-form #termsCheckbox')
            .on('change.dyojTerms', '.dyoj-customize-form #termsCheckbox', function () {
                var $form = $(this).closest('form');
                if ($(this).is(':checked')) {
                    $form.find('.dyoj-terms-error').addClass('d-none').removeClass('d-block');
                }
            });

        $(document)
            .off('submit.dyojCustomize', '.dyoj-customize-form')
            .on('submit.dyojCustomize', '.dyoj-customize-form', function (e) {
                e.preventDefault();

                var $form = $(this);

                // Ensure native validation doesn't block our submit handler
                $form.attr('novalidate', 'novalidate');

                var hasError = false;
                var uploadFileExist = $('#inspirationImages').length > 0;

                // Terms is mandatory
                if (!$form.find('#termsCheckbox').is(':checked')) {
                    $form.find('.dyoj-terms-error').removeClass('d-none').addClass('d-block');
                    // self.showAlert(self.getMessage('terms-required') || 'Please accept terms and conditions.');
                    hasError = true;
                } else {
                    $form.find('.dyoj-terms-error').addClass('d-none').removeClass('d-block');
                }

                // Validate required fields (no scrolling)
                if (!self.validateCustomizeForm($form)) {
                    // self.showAlert(self.getMessage('missing-fields') || 'Please fill all required fields.');
                    hasError = true;
                }

                if (hasError) {
                    self.scrollToFirstError();
                    return false;
                }

                // Copy textarea value to hidden field
                var customRequirements = $('.custom-requirements-textarea').val();
                $form.find('.custom-requirements-hidden').val(customRequirements);

                var formData = new FormData($form[0]);

                // Manually append files since input is outside the form tag
                if (self.selectedFiles && self.selectedFiles.length) {
                    $.each(self.selectedFiles, function (i, file) {
                        formData.append('inspirationImages', file);
                    });
                }

                // Manually append video link since input is outside the form tag
                var $videoLink = $('input[name="videoReferenceLink"]');
                if ($videoLink.length && $videoLink.val()) {
                    formData.append('videoReferenceLink', $videoLink.val());
                }

                // append product name
                var dyojProductName = $('#dyojProductName').val();
                formData.append('productName', dyojProductName);
                formData.append('productPageURL', window.location.href);

                // Disable submit button during request
                var $submitBtn = $form.find('.dyoj-submit-btn');
                if ($submitBtn.length) {
                    $submitBtn.prop('disabled', true);
                }

                $.ajax({
                    url: $form.attr('action'),
                    method: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function (response) {
                        if (response.success) {
                            var $successResponseModal = $('#dyojcustomizesuccessresponse');
                            $successResponseModal.modal('show');
                            // reset the form
                            self.selectedFiles = [];
                            self.displaySelectedFiles(self.selectedFiles);
                            $('.custom-requirements-textarea').val('').trigger('input');
                            $form[0].reset();
                            // date picker reset
                            var $dateInput = $('#dyojDeliveryDate');
                            if ($.fn.datepicker && typeof $dateInput.datepicker === 'function') {
                                $dateInput.datepicker('clearDates');
                            }

                            // Reset selected products display
                            $('#selectedDiamondDisplay, #selectedGemstoneDisplay').hide();
                            $('#selectedDiamondName, #selectedGemstoneName').text('');
                            $('#selectedDiamond, #selectedGemstone').val('');
                            $('#selectedDiamondNameField, #selectedGemstoneNameField').val('');
                            $form.find('#dyoj-qty-plus').removeClass('disablestate max-disabled').prop('disabled', false);
                            if (uploadFileExist) {
                                self.updateFileInput();
                            }
                        } else {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                                return;
                            }
                            var $errorResponseModal = $('#dyojcustomizeerrorresponse');
                            var errorMessage = response.message || self.getMessage('error');
                            $errorResponseModal.find('.message-text').text(errorMessage);
                            $errorResponseModal.modal('show');
                            // Auto-hide after 5 seconds
                            setTimeout(function () {
                                $errorResponseModal.modal('hide');
                            }, 5000);
                        }
                        // Re-enable submit button on error
                        if ($submitBtn.length) {
                            $submitBtn.prop('disabled', false);
                        }
                    },
                    error: function () {
                        // Re-enable submit button on error
                        if ($submitBtn.length) {
                            $submitBtn.prop('disabled', false);
                        }
                        // self.showAlert(self.getMessage('error'));
                    }
                });

                return false;
            });
    },

    /**
     * Initialize terms & conditions modal behaviour
     */
    initTermsAndConditionsModal: function () {
        var $form = $('.dyoj-customize-form');
        if (!$form.length) return;

        var openTermsModal = function ($currentForm) {
            var $termsCheckbox = $currentForm.find('#termsCheckbox');
            if ($termsCheckbox.is(':checked')) {
                $termsCheckbox.prop('checked', false);
            }
            $('#dyoj-terms-modal').modal('show');
        };

        $form.on('click', '.terms-and-conditions .form-check-label, .terms-and-conditions .dyoj-terms-readmore', function (e) {
            e.preventDefault();

            var $currentForm = $(this).closest('form');
            openTermsModal($currentForm);

            return false;
        });

        $form.on('click', '.terms-and-conditions .ckc-checkbox', function (e) {
            if ($(e.target).closest('a').length) {
                return;
            }

            e.preventDefault();

            var $currentForm = $(this).closest('form');
            openTermsModal($currentForm);
        });

        $(document).on('click', '#dyoj-agree-btn, #dyoj-terms-agree-btn', function () {
            var $currentForm = $('.dyoj-customize-form');
            var $termsCheckbox = $currentForm.find('#termsCheckbox');
            $termsCheckbox.prop('checked', true).trigger('change');
            $('#dyoj-terms-modal').modal('hide');
            $currentForm.find('.dyoj-terms-error').addClass('d-none').removeClass('d-block');
        });
    },

    /**
     * Handle product selection (diamonds, gemstones, etc.)
     */
    handleProductSelection: function () {
        var self = this;

        $(document).on('click', '[data-action="select-product"]', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var categoryId = $btn.data('category-id');
            var url = $btn.data('url');
            var attrType = $btn.data('type');
            var buttonText = ($btn.text() || '').toString().trim();
            var type = attrType || (buttonText.toUpperCase().indexOf('DIAMOND') !== -1 ? 'diamonds' : 'gemstones');
            $('#product-selection-modal').data('originBtn', $btn);
            $('#product-selection-modal').off('hidden.bs.modal.dyojOrigin').on('hidden.bs.modal.dyojOrigin', function () {
                $(this).removeData('originBtn');
            });

            self.openProductSelectionModal(type, categoryId, url);
        });
    },

    /**
     * Opens the product selection modal and loads products via AJAX.
     * @param {string} type - Product type (e.g. 'diamonds' or 'gemstones')
     * @param {string} categoryId - Category ID used to fetch products
     * @param {string} url - Endpoint URL to retrieve product data
     */
    openProductSelectionModal: function (type, categoryId, url) {
        var $modal = $('#product-selection-modal');
        var $grid = $('#productSelectionGrid');

        // Set modal title
        var title = type === 'diamonds'
            ? this.getMessage('select-diamonds')
            : this.getMessage('select-gemstones');
        $modal.find('.modal-title').text(title);

        // Show loading state
        var loadingMsg = this.getMessage('loading') || 'Loading...';
        $grid.html('<div class="text-center py-5"><div class="spinner-border" role="status"><span class="sr-only">' + loadingMsg + '</span></div></div>');

        if (!url) {
            $grid.html(this.createCenteredMessage(this.getMessage('url-error') || 'URL not provided.'));
            return;
        }

        // Fetch products via AJAX
        $.ajax({
            url: url,
            method: 'GET',
            data: { cgid: categoryId, type: type },
            dataType: 'html', // expect HTML to inject directly
            success: function (html) {
                $grid.html(html);
                // Open modal
                $modal.modal('show');
            },
            error: function () {
                $grid.html(this.createCenteredMessage(this.getMessage('load-error') || 'Unable to load products.'));
            }.bind(this)
        });
    },

    /**
     * Handle product view button
     */
    handleProductView: function () {
        $(document).on('click', '.btn-view-product', function () {
            var pid = $(this).data('pid');
            var productUrl = $('#productShowUrl').val();
            var fullUrl = productUrl.indexOf('?') > -1 ? productUrl + '&pid=' + pid : productUrl + '?pid=' + pid;
            window.open(fullUrl, '_blank');
        });
    },

    /**
     * Handle product select button
     */
    handleProductSelect: function () {
        var self = this;

        $(document).on('click', '.btn-select-product', function (e) {
            e.preventDefault();

            var $btn = $(this);
            var pid = $btn.data('pid');
            var name = $btn.data('name');
            var rawType = ($btn.data('type') || '').toString();
            var buttonText = ($btn.text() || '').toString().toLowerCase();
            var type = rawType ? rawType.toLowerCase() : '';

            if (!type) {
                type = buttonText.indexOf('diamond') !== -1 ? 'diamonds' : 'gemstones';
            }
            if (type !== 'diamonds' && type !== 'gemstones') {
                type = 'diamonds';
            }

            if (!pid || !name) {
                return;
            }

            var $modal = $('#product-selection-modal');
            var $origin = $modal.data('originBtn') || $();

            var $wrapper = $origin.length
                ? $origin.closest('.btn-wrapper')
                : $('.dyoj-customize-product')
                    .find('[data-action="select-product"][data-type="' + type + '"]')
                    .first()
                    .closest('.btn-wrapper');

            var isDiamond = type === 'diamonds';
            var pidSelector = isDiamond ? 'input[name="selectedDiamond"]' : 'input[name="selectedGemstone"]';
            var nameSelector = isDiamond ? 'input[name="selectedDiamondName"]' : 'input[name="selectedGemstoneName"]';
            var $globalDisplay = isDiamond ? $('#selectedDiamondDisplay') : $('#selectedGemstoneDisplay');
            var $globalLabel = isDiamond ? $('#selectedDiamondName') : $('#selectedGemstoneName');
            var $globalPidField = isDiamond ? $('#selectedDiamond') : $('#selectedGemstone');
            var $globalNameField = isDiamond ? $('#selectedDiamondNameField') : $('#selectedGemstoneNameField');

            if ($wrapper && $wrapper.length) {
                var $pidField = $wrapper.find(pidSelector).first();
                var $nameField = $wrapper.find(nameSelector).first();

                if ($pidField.length) {
                    $pidField.val(pid);
                    self.clearFieldError($pidField);
                }

                if ($nameField.length) {
                    $nameField.val(name);
                }

                $wrapper.find('.selected-product-text').text(name);
                $wrapper.find('.selected-product-display').fadeIn();
            } else {
                if ($globalPidField.length) {
                    $globalPidField.val(pid);
                    self.clearFieldError($globalPidField);
                }

                if ($globalNameField.length) {
                    $globalNameField.val(name);
                }

                if ($globalLabel.length) {
                    $globalLabel.text(name);
                }

                if ($globalDisplay.length) {
                    $globalDisplay.fadeIn();
                }
            }

            $modal.modal('hide');
        });
    },

    /**
     * Initialize custom dropdowns
     */
    initCustomDropdowns: function () {
        var self = this;

        // Ensure dropdown menus start closed (no inline style)
        $('.dyoj-customize-product .custom-option-values').addClass('d-none');

        // Handle custom dropdown option clicks
        $('.dyoj-customize-product').on('click', '.custom-option-value', function () {
            var $option = $(this);
            var $section = $option.closest('.custom-drop-down-section');
            var $select = $section.siblings('select');
            var selectedValue = $option.data('id');
            var selectedText = $option.text().trim();

            // Update hidden select value
            if ($select.length) {
                $select.val(selectedValue);
                self.clearFieldError($select);
            }

            // Update UI
            $section.find('.custom-option-value').removeClass('selected');
            $option.addClass('selected');
            $section.find('.selected-value').text(selectedText).removeClass('is-empty');
            $section.find('.custom-option-values').addClass('d-none');
            $section.find('.down-arrow').removeClass('rotate-arrow');
        });

        // Clear quantity error on user edits
        $(document)
            .off('input.dyojQtyValidate change.dyojQtyValidate', '.dyoj-customize-form input[name="quantity"]')
            .on('input.dyojQtyValidate change.dyojQtyValidate', '.dyoj-customize-form input[name="quantity"]', function () {
                self.clearFieldError($(this));
            });

        // Toggle dropdown on click
        $('.dyoj-customize-product').on('click', '.custom-drop-down', function (e) {
            e.stopPropagation();
            var $section = $(this).closest('.custom-drop-down-section');
            var $options = $section.find('.custom-option-values');
            var $arrow = $section.find('.down-arrow');

            // Close other dropdowns
            $('.dyoj-customize-product .custom-option-values').not($options).addClass('d-none');
            $('.dyoj-customize-product .down-arrow').not($arrow).removeClass('rotate-arrow');

            // Toggle this dropdown
            if ($options.hasClass('d-none') || $options.css('display') === 'none') {
                $options.removeClass('d-none').css('display', 'block');
                $arrow.addClass('rotate-arrow');
            } else {
                $options.addClass('d-none').css('display', 'none');
                $arrow.removeClass('rotate-arrow');
            }
        });

        // Close dropdown when clicking outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.custom-drop-down').length) {
                $('.dyoj-customize-product .custom-option-values').addClass('d-none');
                $('.dyoj-customize-product .down-arrow').removeClass('rotate-arrow');
            }
        });
    },

    /**
     * Initialize DYOJ product carousels
     */
    initSlickCarousel: function () {
        if ($('.dyoj-slick-carousel').length) {
            $('.dyoj-slick-carousel').each(function () {
                var $carousel = $(this);
                // Destroy existing slick instance if any
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }

                // Initialize slick
                $carousel.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            });
        }
    },

    /**
     * Handle DYOJ product tile button clicks
     */
    handleProductTileButtons: function () {
        $('body').on('click', '.use-inspiration-btn, .dyoj-customise-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var isAuthenticated = $('#isAuthenticated').val();
            var dyojPdpUrl = $(this).data('url');

            if (dyojPdpUrl) {
                localStorage.setItem('dyojPdpUrl', dyojPdpUrl);
            }

            if (isAuthenticated === 'true') {
                window.open(dyojPdpUrl, '_blank');
            } else {
                $('#ckc-login-modal').modal('show');
            }
        });
    },

    /**
     * Handle non-dyoj submit button click
     */
    handleNonDyojSubmit: function () {
        $('body').on('click', '.non-dyoj-submit-btn', function () {
            $('#ckc-login-modal').modal('show');
        });
    },

    /**
     * Initialize Read More / Read Less toggle functionality
     */
    initReadMoreToggle: function () {
        $(document).on('click', '.read-more-toggle', function (e) {
            e.preventDefault();

            var $toggleLink = $(this);
            var $description = $toggleLink.closest('.help-description');

            $description.toggleClass('is-expanded');

            var isExpanded = $description.hasClass('is-expanded');
            var readMoreText = $toggleLink.data('read-more-text') || 'Read More.';
            var readLessText = $toggleLink.data('read-less-text') || 'Read Less.';

            $toggleLink.text(isExpanded ? readLessText : readMoreText);
        });
    },

    /**
     * Enforce max words and update words-left counter for requirements textarea
     */
    initRequirementsWordLimit: function () {
        var maxWords = 500;

        $(document).on('input', 'textarea.custom-requirements-textarea', function () {
            var $textarea = $(this);
            var text = ($textarea.val() || '').trim();
            var words = text.length ? text.split(/\s+/).filter(Boolean) : [];

            if (words.length > maxWords) {
                words = words.slice(0, maxWords);
                $textarea.val(words.join(' '));
            }

            var value = $textarea.val();

            // Prevent input beyond max length
            if (value.length >= maxWords) {
                $textarea.val(value.substring(0, maxWords));
            }

            $textarea.closest('.form-group').find('.max-words').text((maxWords - value.length) + ' words max');
        });

        $('textarea.custom-requirements-textarea').trigger('input');
    },

    invalidData: function () {
        $(document).on('change', '#dyojDeliveryDate', function () {
            if ($(this).val().trim()) {
                $('.dyoj-customize-form .date-picker').removeClass('is-invalid');
                $('.invalid-feedback.invalid-dyojDeliveryDate').text('');
            }
        });
    },

    /**
     * Initialize all handlers
     */
    init: function () {
        this.initQuantityControls();
        this.initCustomDropdowns();
        this.initFileUpload();
        this.initDeliveryDate();
        this.initSlickCarousel();
        this.initRequirementsWordLimit();
        this.initTermsAndConditionsModal();
        this.handleFormSubmit();
        this.handleProductSelection();
        this.handleProductView();
        this.handleProductSelect();
        this.handleProductTileButtons();
        this.handleNonDyojSubmit();
        this.initReadMoreToggle();
        this.invalidData();
        this.initVideoLinkValidation();
    }
};
